import { Component, OnDestroy, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';
import { Element, AutomatedTestArea } from '../models/ast-element.model';
import { TylerMatTableDataSource } from '../../../shared-components/angular-material/extended.class';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { Subscription } from 'rxjs';
import { MenuItem } from '../../../shared-components/controls/menus/menu-item.model';


@AutoUnsubscribe()
@Component({
    selector: 'ElementAddEditModalComponent',
    templateUrl: './element-add-edit-modal.component.html',
    styleUrls: ['./element-add-edit-modal.component.css']
})

export class ElementAddEditModalComponent implements OnDestroy, OnInit {

    PageTitle: string;
    Message: string;

    dataSource: TylerMatTableDataSource;

     @ViewChild(MatPaginator) paginator: MatPaginator;

    allElements: Element[] = [];
    allAreas: AutomatedTestArea[] = [];
    distinctTestAreas: AutomatedTestArea[] = [];
    distinctElements: Element[] = [];
    selectedArea: AutomatedTestArea[] = []; // This is used to set the Area ID
    selection: string;

    elemAreas: string[] = [];
    elemSubAreas: string[] = [];
    allControlNames: string[] = [];

    elementArea: string;
    elementSubArea: string;
    elementControlName: string;
    newModuleName: string;
    newPortalName: string;
    elementId: number;
    areaId: number;

    elementName: string;
    @ViewChild('NewElementName') name: ElementRef;

    elementXPath: string;
    @ViewChild('NewElementXPath') xpath: ElementRef;

    @ViewChild('NewAreaName') module: ElementRef;

    @ViewChild('NewPortalName') portal: ElementRef;

    newElement: Element = {
        Element_ID: 0,
        ElementArea_ID: 0,
        ElementName: '',
        ElementAreaName: '',
        ElementSubAreaName: '',
        ElementSubAreas: [],
        ControlName: '',
        XPath: '',
        ParameterName: '',
        ParameterValue: '',
        Action: '',
        Actions: []
    };

    newArea: AutomatedTestArea = {
        Area_ID: 0,
        AreaName: '',
        SubAreaName: ''
    };

     // ----------Angular Material------------------------------------
     angularMatData = new TylerMatTableDataSource();
     @ViewChild(MatSort, { static: true }) sort: MatSort;
     columnsToDisplay: string[] = []
     subscriptions: Subscription[] = [];

    constructor(
        private reportService: ReportingService,
        private dialogRef: MatDialogRef<ElementAddEditModalComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any,
    ) {
        this.PageTitle = data.PageTitle;
        this.Message = data.Message;

        this.elementArea = data.elementArea;
        this.elementSubArea = data.elementSubArea;
        this.elementName = data.elementName;
        this.elementXPath = data.elementXPath;
        this.elementControlName = data.elementControlName;
        this.elementId = data.elementId;
    }

    ngOnInit() {
        this.getTestAreas();
        this.getControlTypes();
    }

    ngOnDestroy() { }

    okClick() {
        switch (this.PageTitle) {
            case 'Create New Element':
                this.createNewElement();
                break;
            case 'Update Element':
                this.updateElement();
                break;
            default:
                alert('This functionality not yet implemented.');
                break;
        }
    }

    cancelClick() {
        this.dialogRef.close(false);
    }

    setElementArea(area: AutomatedTestArea) {
        this.elementArea = area.AreaName;
    }

    setElementSubArea(subarea: string) {
        this.elementSubArea = subarea;
    }

    setElementName() {
        this.elementName = this.name.nativeElement.value;
    }

    setElementXPath() {
        this.elementXPath = this.xpath.nativeElement.value;
    }

    setElementControl(controlname: string) {
        this.elementControlName = controlname;
    }

    getTestAreas() {
        this.reportService.getAutomatedTestAreas(0).subscribe(myAreas => {
            this.allAreas = myAreas;
            this.distinctTestAreas = this.allAreas.filter(
                (thing, i, arr) => arr.findIndex(t => t.AreaName === thing.AreaName) === i
              );
            this.distinctTestAreas.sort((a, b) => a.AreaName > b.AreaName ? 1 : -1);
        });
    }

    getElements(area: AutomatedTestArea) {
        // get elements for test
        this.reportService.getAutomatedTestElements(0).subscribe(elem => {
            this.allElements = elem;
            this.allElements = this.allElements.filter(e => e.ElementAreaName == area.AreaName);
            this.allElements.sort((a, b) => a.ElementName > b.ElementName ? 1 : -1);
        });
    }

    getSubAreas(areaName: string) {
        const filteredAreas = this.allAreas.filter(a => a.AreaName === areaName).sort((a, b) => a.SubAreaName > b.SubAreaName ? 1 : -1);

        for (const item of filteredAreas) {
            this.elemSubAreas.push(item.SubAreaName);
        }
    }

    createNewElement() {
        // Assemble the new element from the information that has been input by the user
        this.setElementName();
        this.setElementXPath();

        this.newElement.ElementAreaName = this.elementArea;
        this.newElement.ElementSubAreaName = this.elementSubArea;
        this.newElement.ElementName = this.elementName;
        this.newElement.XPath = this.elementXPath;
        this.newElement.ControlName = this.elementControlName;

        if (this.elementArea === undefined
            || this.elementSubArea === undefined
            || this.elementName === undefined
            || this.elementName === ''
            || this.elementXPath === undefined
            || this.elementXPath === ''
            || this.elementControlName === undefined) {
                alert('Please make sure that all of the fields are populated.');
        } else {
            // Save the new element to the AST_Elements table
           this.reportService.saveAutomatedTestElement(this.newElement).subscribe(results => { });

           alert(`New element ${ this.elementName } successfully created.`);

           this.dialogRef.close(true);
        }
    }

    updateElement() {
        this.setElementName();
        this.setElementXPath();
        this.newElement.ElementAreaName = this.elementArea;
        this.newElement.ElementSubAreaName = this.elementSubArea;
        this.newElement.ElementName = this.elementName;
        this.newElement.XPath = this.elementXPath;
        this.newElement.ControlName = this.elementControlName;

        if (this.elementArea === undefined
            || this.elementSubArea === undefined
            || this.elementName === undefined
            || this.elementName === ''
            || this.elementXPath === undefined
            || this.elementXPath === ''
            || this.elementControlName === undefined
            ) {
                alert('Please make sure that all of the fields are populated.');
        } else if (this.elementId === undefined) {
            alert("Ain't got no legs, Lieutenant Dan.");
        } else {
            // Save the new element to the AST_Elements table
           this.reportService.updateAutomatedTestElement(this.elementId, this.newElement).subscribe(results => { });

           alert(`Element ${ this.elementName } successfully updated.`);

           this.dialogRef.close(true);
        }
    }

    getControlTypes() {
        // get elements to pull control types from
        this.reportService.getAutomatedTestElements(0).subscribe(elem => {
            this.allElements = elem;

            for (const item of this.allElements) {
                if (!(this.allControlNames.includes(item.ControlName, 0))) {
                    this.allControlNames.push(item.ControlName);
                    this.allControlNames.sort((a, b) => a > b ? 1 : -1);
                }
            }
        });
    }

}
